import {
  BaseFullSchema_OLD,
  BaseRefSchema,
  BaseCreateSchema,
  PaginatedResponse,
  IdAsUUID,
} from "./common/commonTypes";
export const LOCATION_TYPES = [
  "BIN",
  "CAGE",
  "CART",
  "FACILITY",
  "ROOM",
  "SHELF",
  "SHELF_UNIT",
] as const;
export type LocationType = (typeof LOCATION_TYPES)[number];

export interface LocationFull extends BaseFullSchema_OLD {
  name: string;
  location_type: LocationType;
  facility_code?: string;
  is_bin: boolean;
  is_default_receiving_bin: boolean;
  top_location_name: string;

  parent_location?: LocationRef;
  child_locations?: LocationRef[];
}

export interface LocationRef extends BaseRefSchema {
  name: string;
  location_type: LocationType;
  is_bin: boolean;
  is_default_receiving_bin: boolean;
  parent_location_id?: IdAsUUID;
}

export interface LocationCreate extends BaseCreateSchema {
  name: string;
  location_type: LocationType;
  parent_location_id?: string;
  facility_code?: string;
  is_default_receiving_bin: boolean;
}

export interface LocationUpdate extends Partial<LocationCreate> {
  id: string;
}
export type PaginatedLocationResponse = PaginatedResponse<LocationFull>;
